import React from 'react';
import css from '../../styles/modules/common/skeletonLoader.module.css';

export default function SkeletonLoader({ width, height }) {
  return <div className={css.skeleton} style={{ width, height }}></div>;
}
